import { exportToExcel } from "../../utils/ExportUtils";
const ExportHandlerEmployeeSkillSet = ({ searchResults, selectedRowKeys }) => {
  const handleExport = () => {
   
    let rowsToExport;
   
    if (selectedRowKeys.length > 0) {
      // Handle selected rows (selectedRowKeys is a non-empty array)
      rowsToExport = searchResults.filter((row) =>
        selectedRowKeys.includes(row.uid)
      );
    
      
    } else {
      
      // Handle all rows (selectedRowKeys is an empty array)
      rowsToExport = searchResults; // All rows
     
    }
    if (rowsToExport.length === 0) {
      console.warn("No rows selected for export.");
    }

    const formattedData = rowsToExport.map((row) => ({
      ...row,    
      certifications: row.certifications ? row.certifications.join("\n") : "", 
    }));



    const mainHeader = "Employee Competency Details";
    const columnHeaders = [
      { key: "uid", label: "UID", width: 10 },
      { key: "name", label: "EMPLOYEE NAME", width: 25 },
      { key: "overallExp", label: "TOTAL EXP", width: 10 },
      { key: "primarySkill", label: "PRIMARY SKILL", width: 18 },
      { key: "expInPrimarySkill", label: "PRIMARY SKILL EXP", width: 18 }, 
      { key: "status", label: "STATUS", width: 10 },   
      { key: "location", label: "LOCATION", width: 15 },
      { key: "certifications", label: "CERTIFICATIONS", width: 40 },
      
    ];

    const now = new Date();
    const formattedDateTime = `${now.getFullYear()}-${String(
      now.getMonth() + 1
    ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}_${String(
      now.getHours()
    ).padStart(2, "0")}-${String(now.getMinutes()).padStart(2, "0")}-${String(
      now.getSeconds()
    ).padStart(2, "0")}`;

    const fileName = `Export_${formattedDateTime}.xlsx`;
    const sheetName = "Employees";

    exportToExcel(
      formattedData,
      fileName,
      sheetName,
      mainHeader,
      columnHeaders
    );
  };

  return handleExport;
};

export default ExportHandlerEmployeeSkillSet;